import { DateOnly } from '@if/core/date'
import { t } from '@if/core/i18n'
import { dateOnly, InferSubmit, numberEnum, object, text } from '@if/core/yup'
import { getToday } from '@src/services/DateTimeProvider'
import { getEMetro2ReportingReasonList } from '@src/types/constants'

/**
 * The first day of the month the agent is in. Everything before it has already been sent to
 * the bureaus, so it is the floor a reporting date may land on.
 */
export const getFirstDayOfCurrentMonth = (): DateOnly => {
  const today = getToday()
  return DateOnly.fromComponents(today.getFullYear(), today.getMonth(), 1)
}

/**
 * What the agent fills in for one bureau-reporting record. The rest of the record — who
 * wrote it, when, and whether it has been reported — is composed by the dialog that owns it,
 * never typed.
 */
export const Metro2ReportingSchema = object({
  metro2OverrideDate: dateOnly()
    .required()
    .test(
      'metro2OverrideDate-notBeforeCurrentMonth',
      () => t('loan.error.earlierOfCurrentMonth'),
      (value) => !value || value.getTime() >= getFirstDayOfCurrentMonth().getTime(),
    ),
  metro2ReportingReason: numberEnum(getEMetro2ReportingReasonList()).required().default(null),
  description: text(),
})

export type Metro2ReportingSchemaType = InferSubmit<typeof Metro2ReportingSchema>
